import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addSpaceIfNeeded } from "./addSpaceIfNeeded";

export const addTableSummaryToLayout = (
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.summary;

  Object.keys(campaigns).forEach((key) => {
    const campaign = campaigns[key];
    const { publicationsSummary } = campaign;

    if (
      !publicationsSummary ||
      (aggregation && key !== "aggregated") ||
      (!aggregation && key === "aggregated")
    ) {
      return;
    }

    if (
      !aggregation &&
      key !== "aggregated" &&
      Object.keys(campaigns).length > 1
    ) {
      addHeaderToLayout(`table-summary-${key}`, newLayout, format, 2);
    }

    Object.entries(publicationsSummary).forEach((item, index) => {
      const [provider, data] = item;

      const w = 12;

      const pubCount = data.publications.length;
      const spaceForHeader = index === 0 ? 1 : 0;
      const firstPartHeight = (pubCount >= 13 ? 13 : pubCount) + spaceForHeader;

      const isSingleCampaign = Object.keys(campaigns).length === 1;
      const headerDepth = key !== "aggregated" && !isSingleCampaign ? 3 : 2;

      addHeaderToLayout(
        `table-summary-${provider}-${key}`,
        newLayout,
        format,
        headerDepth,
        !spaceForHeader,
        w,
        firstPartHeight + 1,
      );

      const tableParts = Math.ceil((pubCount + 3 + spaceForHeader) / 15);

      for (let i = 1; i <= tableParts; i++) {
        const h = getTableHeight(i, pubCount, tableParts, spaceForHeader);

        const lastEl = addSpaceIfNeeded(
          "table-summary",
          newLayout,
          format,
          w,
          h,
        );

        const x = 0;
        const y = lastEl.y + lastEl.h;

        newLayout.push({
          i: `table-summary-${provider}-${key}-${i}`,
          x,
          y,
          w,
          h,
        });
      }
    });
  });
};

const getTableHeight = (i, pubCount, tableParts, spaceForHeader) => {
  if (i === 1) {
    if (tableParts === 1) {
      return pubCount + 2;
    }
    return 15 - spaceForHeader;
  }

  if (i === tableParts) {
    return pubCount + spaceForHeader + 3 - (tableParts - 1) * 15;
  }

  return 16;
};
